import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Media } from 'reactstrap';

const Heading = ({ title, subtitle, className, icon, transform, loading }) => (
  <Media className={className}>
    <span className="fa-stack ml-n1 mr-2">
      <FontAwesomeIcon icon="circle" color={'white'} className="branding-blue fa-stack-2x" />
      <FontAwesomeIcon icon={icon} transform={transform} className="text-white fa-stack-1x" inverse />
    </span>
    <Media body>
      <Media heading tag="h5" className="text-primary position-relative mb-0">
        <span className={`${loading ? 'loading-skeleton' : ' '} bg-white pr-3 text-grotesque`} data-testid={'heading'}>
          {title}
        </span>
        <span className="border border-dark border-3 position-absolute absolute-vertical-center w-100 z-index--1 l-0" />
      </Media>
      <div className="mw-100">
        <p className="mb-0">{subtitle}</p>
      </div>
    </Media>
  </Media>
);

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  transform: PropTypes.string,
  loading: PropTypes.bool
};

export default Heading;
